module.exports = __webpack_public_path__ + "hero-our-work@2x.3jLnwQzP.png";